module.exports = __webpack_public_path__ + "img/7.ca86b9fd.png";